import { createSelector } from 'reselect';
import { getProjectListState } from 'src/modules/project-list/selectors/getProjectListState';

export const getProjectListUnfollowing = createSelector([
  getProjectListState,
], (state) => state.unfollowing);
